<div class="card flex justify-content-center">
  <p-galleria
    [value]="images"
    [(visible)]="displayBasic"
    [responsiveOptions]="responsiveOptions"
    [numVisible]="7"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
  >
    <ng-template pTemplate="item" let-item>
      <img [src]="item.itemImageSrc" class="fullscreen-image"/>
    </ng-template>
  </p-galleria>
</div>

